import styled from 'styled-components';
import Text from '../../../../../typography';

export const InputPrefixSC = styled.div`
  height: 36px;
  padding: 0 12px;

  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const InputSeparator = styled.span`
  height: 24px;
  margin-left: 12px;
  border-right: 1px solid 'transparent';
`;

export const PrefixTextSC = styled(Text)``;
